import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { firstValueFrom, map, of, take, timeout } from 'rxjs';
import { BusinessProfileFeatureFlagService } from '../services/feature-flags/business-profile-feature-flag.service';
import { FinancialAnalysisRouteAccess } from './financial-analysis-route-access.model';

const FEATURE_STATE_GUARD_TIMEOUT_MS = 6000;

export const financialAnalysisFeatureGuard: CanActivateFn = async (): Promise<
  boolean | UrlTree
> => {
  const router = inject(Router);
  const businessProfileFeatureFlagService = inject(
    BusinessProfileFeatureFlagService,
  );

  businessProfileFeatureFlagService.initialize();

  const routeAccess = await firstValueFrom(
    businessProfileFeatureFlagService.featureState$.pipe(
      take(1),
      timeout({
        first: FEATURE_STATE_GUARD_TIMEOUT_MS,
        with: () =>
          of({
            featureFlagId: 'cycle-risk-portfolio-financial-analysis-enable',
            isEnabled: false,
            source: 'unavailable' as const,
            resolvedAt: Date.now(),
          }),
      }),
      map((featureState): FinancialAnalysisRouteAccess => ({
        routePath: '/financial-analysis',
        canActivate: featureState.isEnabled,
        redirectTo: featureState.isEnabled ? null : '/home',
      })),
    ),
  );

  if (routeAccess.canActivate) {
    return true;
  }

  return router.createUrlTree([routeAccess.redirectTo ?? '/home']);
};
